import { createAction } from '@reduxjs/toolkit'
import { PerpOrderRecord, PerpPositionClearingsRecord } from 'api/v1/perp'
import { OrderDirection, OrderModeNames } from 'store/spot/types'
import { SymbolName } from 'types'
import {
  PerpCreateOrderOption,
  PerpLastInputAmountType,
  PerpOrderTabType,
} from './types'
import { WsOrderMessage } from '../../ws/zkex/messages/orders'

export const updateCurrentPerpSymbol = createAction<number>(
  'perp/updateCurrentPerpSymbol'
)
export const cleanUserPerpDataAction = createAction(
  'perp/cleanUserPerpDataAction'
)
export const updatePerpOrderRecordAction = createAction<
  WsOrderMessage<PerpOrderRecord>
>('perp/updatePerpOrderRecordAction')
export const updateClosingPositionStatusAction = createAction<
  WsOrderMessage<PerpOrderRecord>
>('perp/updateClosingPositionStatusAction')

export const updatePerpBadgeOrderAction = createAction<boolean>(
  'perp/updatePerpBadgeOrderAction'
)
export const updatePerpBadgeTradeAction = createAction<boolean>(
  'perp/updatePerpBadgeTradeAction'
)
export const updatePerpCreateOrderOption = createAction<{
  option: keyof PerpCreateOrderOption
  value: string
}>('perp/updatePerpCreateOrderOption')
export const updatePerpSelectedOrderMode = createAction<OrderModeNames>(
  'perp/updatePerpSelectedOrderMode'
)
export const updatePerpLastInputAmountType =
  createAction<PerpLastInputAmountType>('perp/updatePerpLastInputAmountType')
export const updatePerpOrderDirection = createAction<OrderDirection>(
  'perp/updatePerpOrderDirection'
)
export const updateClosePositionSymbolsAction = createAction<SymbolName[]>(
  'perp/updateClosePositionSymbolsAction'
)
export const updatePerpCurrentOrderTab = createAction<PerpOrderTabType>(
  'perp/updatePerpCurrentOrderTab'
)
export const updateCancelPerpPendingIds = createAction<number[]>(
  'perp/updateCancelPerpPendingIds'
)
export const updatePerpPositionClearingsAction = createAction<
  WsOrderMessage<PerpPositionClearingsRecord>
>('perp/updatePerpPositionClearingsAction')
export const updateCloseAllPerpState = createAction<boolean>(
  'perp/updateCloseAllPerp'
)
export const updateCancelAllPerpState = createAction<boolean>(
  'perp/updateCancelAllPerp'
)
export const addClosePositionOrderIds = createAction<number[]>(
  'perp/addClosePositionOrderId'
)
export const updatePerpPostOnlyAction = createAction<boolean>(
  'perp/updatePerpPostOnlyAction'
)
